<template>
  <div class="flex flex-col gap-5">
    <!--  COST BARGING OPERATION  -->
    <div class="h-full w-full p-5 flex flex-col gap-3 card-border">
      <div class="pb-3 flex flex-row items-center justify-between border-b-2 border-dashed">
        <span class="text-xl font-semibold">
          Cost Barging Operation (USD)
        </span>
        <div class="flex flex-row items-center justify-between gap-2">
          <date-picker
            v-model="filter.barging_operation_month"
            format="MMMM"
            type="month"
            value-type="M"
            placeholder="Month"
            hide-year-label
          />
        </div>
      </div>
      <div class="w-full section-container">
        <div class="w-1/5 flex flex-col gap-3">
          <div class="summary-card card-border">
            <span class="text-xl font-semibold">
              Total year
            </span>
            <div class="flex flex-col gap-3">
              <span>Budget</span>
              <div>
                <span class="text-3xl font-semibold">
                  {{ costBargingOperationSummary ? formatNumber(costBargingOperationSummary.annualSummary.budget): null }}
                </span>
                <span>
                  USD
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-3">
              <span>Outlook</span>
              <div>
                <span
                  class="text-3xl font-semibold"
                  :class="[
                    generateOutlookClass(
                      costBargingOperationSummary.annualSummary.budget,
                      costBargingOperationSummary.annualSummary.outlook
                    )
                  ].join(' ')"
                >
                  {{ costBargingOperationSummary ? formatNumber(costBargingOperationSummary.annualSummary.outlook): null }}
                </span>
                <span>
                  USD
                </span>
              </div>
            </div>
          </div>
          <div class="summary-card card-border">
            <span class="text-xl font-semibold">
              YTD {{ moment().month(filter.barging_operation_month - 1).format('MMM') }}
            </span>
            <div class="flex flex-col gap-3">
              <span>Budget</span>
              <div>
                <span class="text-3xl font-semibold">
                  {{ costBargingOperationSummary ? formatNumber(costBargingOperationSummary.ytdSummary.budget) : null }}
                </span>
                <span>
                  USD
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-3">
              <span>Outlook</span>
              <div>
                <span
                  class="text-3xl font-semibold"
                  :class="[
                    generateOutlookClass(
                      costBargingOperationSummary.ytdSummary.budget,
                      costBargingOperationSummary.ytdSummary.outlook
                    )
                  ].join(' ')"
                >
                  {{ costBargingOperationSummary ? formatNumber(costBargingOperationSummary.ytdSummary.outlook): null }}
                </span>
                <span>
                  USD
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full h-full flex flex-col justify-center card-border">
          <line-chart
            :data="costBargingOperationChartData"
            :options="lineChartOptions"
            :plugins="lineChartPlugins"
          />
        </div>
      </div>
    </div>

    <!--  VOLUME ALL SITES  -->
    <div class="h-full w-full p-5 flex flex-col gap-3 card-border">
      <div class="pb-3 flex flex-row items-center justify-between border-b-2 border-dashed">
        <span class="text-xl font-semibold">
          Volume: {{ filter.site ? filter.site : 'All Sites' }} (Ton)
        </span>
        <div class="flex flex-row items-center justify-between gap-2">
          <select-with-search
            v-model="filter.site"
            class="w-64"
            placeholder="Select site"
            :options="options.site"
          />
        </div>
      </div>
      <div class="w-full section-container">
        <div class="w-1/5 flex flex-col gap-3">
          <div class="summary-card card-border">
            <span class="text-xl font-semibold">
              Total year
            </span>
            <div class="flex flex-col gap-3">
              <span>Budget</span>
              <div>
                <span class="text-3xl font-semibold">
                  {{ allSitesVolumeSummary ? formatNumber(allSitesVolumeSummary.annualSummary.budget): null }}
                </span>
                <span>
                  Ton
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-3">
              <span>Outlook</span>
              <div>
                <span
                  class="text-3xl font-semibold"
                  :class="[
                    generateOutlookClass(
                      allSitesVolumeSummary.annualSummary.budget,
                      allSitesVolumeSummary.annualSummary.outlook
                    )
                  ].join(' ')"
                >
                  {{ formatNumber(allSitesVolumeSummary.annualSummary.outlook) }}
                </span>
                <span>
                  Ton
                </span>
              </div>
            </div>
          </div>
          <div class="summary-card card-border">
            <span class="text-xl font-semibold">
              YTD {{ moment().month(filters.month || this.moment().format('M') - 1).format('MMM') }}
            </span>
            <div class="flex flex-col gap-3">
              <span>Budget</span>
              <div>
                <span class="text-3xl font-semibold">
                  {{ formatNumber(allSitesVolumeSummary.ytdSummary.budget) }}
                </span>
                <span>
                  Ton
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-3">
              <span>Outlook</span>
              <div>
                <span
                  class="text-3xl font-semibold"
                  :class="[
                    generateOutlookClass(
                      allSitesVolumeSummary.ytdSummary.budget,
                      allSitesVolumeSummary.ytdSummary.outlook
                    )
                  ].join(' ')"
                >
                  {{ formatNumber(allSitesVolumeSummary.ytdSummary.outlook) }}
                </span>
                <span>
                  Ton
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full h-full flex flex-col justify-center card-border">
          <line-chart
            :data="allSitesVolumeChartData"
            :options="lineChartOptions"
            :plugins="lineChartPlugins"
          />
        </div>
      </div>
    </div>

    <!--  BARGING COST  -->
    <div class="h-full w-full p-5 flex flex-col gap-3 bg-white rounded-lg shadow-md">
      <div class="pb-3 flex flex-row items-center justify-between border-b-2 border-dashed">
        <span class="text-xl font-semibold">
          Barging Cost (USD/Ton)
        </span>
        <div class="flex flex-row items-center justify-between gap-2">
          <date-picker
            v-model="filter.barging_cost_month"
            format="MMMM"
            type="month"
            value-type="M"
            placeholder="Month"
            hide-year-label
          />
        </div>
      </div>
      <div class="w-full section-container">
        <div class="w-1/5 flex flex-col gap-3">
          <div class="summary-card card-border">
            <span class="text-xl font-semibold">
              Total year
            </span>
            <div class="flex flex-col gap-3">
              <span>Budget</span>
              <div>
                <span class="text-3xl font-semibold">
                  {{ formatNumber(bargingCostSummary.annualSummary.budget) }}
                </span>
                <span>
                  USD/Ton
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-3">
              <span>Outlook</span>
              <div>
                <span
                  class="text-3xl font-semibold"
                  :class="[
                    generateOutlookClass(
                      bargingCostSummary.annualSummary.budget,
                      bargingCostSummary.annualSummary.outlook
                    )
                  ].join(' ')"
                >
                  {{ formatNumber(bargingCostSummary.annualSummary.outlook) }}
                </span>
                <span>
                  USD/Ton
                </span>
              </div>
            </div>
          </div>
          <div class="summary-card card-border">
            <span class="text-xl font-semibold">
              YTD {{ moment().month(filter.barging_cost_month - 1).format('MMM') }}
            </span>
            <div class="flex flex-col gap-3">
              <span>Budget</span>
              <div>
                <span class="text-3xl font-semibold">
                  {{ formatNumber(bargingCostSummary.ytdSummary.budget) }}
                </span>
                <span>
                  USD/Ton
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-3">
              <span>Outlook</span>
              <div>
                <span
                  class="text-3xl font-semibold"
                  :class="[
                    generateOutlookClass(
                      bargingCostSummary.ytdSummary.budget,
                      bargingCostSummary.ytdSummary.outlook
                    )
                  ].join(' ')"
                >
                  {{ formatNumber(bargingCostSummary.ytdSummary.outlook) }}
                </span>
                <span>
                  USD/Ton
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full h-full flex flex-col justify-center card-border">
          <line-chart
            :data="bargingCostChartData"
            :options="lineChartOptions"
            :plugins="lineChartPlugins"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {slice} from "lodash";
import { mapGetters } from 'vuex';

import DatePicker from '@/components/datePicker'
import LineChart from "@/components/lineChart/index.vue";
import SelectWithSearch from "@/components/selectWithSearch/index.vue";

export default {
  name: 'BargeLogisticMonitoring',
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    DatePicker,
    SelectWithSearch,
    LineChart
  },
  data() {
    const currentMonth = this.moment().format('M')
    return {
      filter: {
        barging_operation_month: currentMonth,
        barging_cost_month: currentMonth,
        site: null
      },
      options: {
        site: []
      },
      costBargingOperationSummary: {
        annualSummary: {},
        ytdSummary: {},
        monthlyRecap: []
      },
      allSitesVolumeSummary: {
        annualSummary: {},
        ytdSummary: {},
        monthlyRecap: []
      },
      bargingCostSummary: {
        annualSummary: {},
        ytdSummary: {},
        monthlyRecap: []
      },
      costBargingOperationChartData: {},
      allSitesVolumeChartData: {},
      bargingCostChartData: {}
    }
  },
  watch: {
    bargeLogisticTargetMonitoring: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val && val.cost_barging_operation) {
          this.costBargingOperationSummary = {
            annualSummary: val.cost_barging_operation.total_year,
            ytdSummary: val.cost_barging_operation.year_to_date,
            monthlyRecap: this.monthsInYear.map(label => {
              const data = val.cost_barging_operation.grouped_by_month.find(item => item.label === label)
              return data || {
                label,
                budget: 0,
                outlook: 0,
                actual: 0,
                unit: 'USD'
              }
            })
          }
          this.costBargingOperationChartData = this.processLineChartData(this.costBargingOperationSummary?.monthlyRecap)

          this.allSitesVolumeSummary = {
            annualSummary: val.volume_tonnage.total_year,
            ytdSummary: val.volume_tonnage.year_to_date,
            monthlyRecap: this.monthsInYear.map(label => {
              const data = val.volume_tonnage.grouped_by_month.find(item => item.label === label)
              return data || {
                label,
                budget: 0,
                outlook: 0,
                actual: 0,
                unit: 'Ton'
              }
            })
          }
          this.allSitesVolumeChartData = this.processLineChartData(this.allSitesVolumeSummary?.monthlyRecap)

          this.bargingCostSummary = {
            annualSummary: val.barging_cost_per_ton.total_year,
            ytdSummary: val.barging_cost_per_ton.year_to_date,
            monthlyRecap: this.monthsInYear.map(label => {
              const data = val.barging_cost_per_ton.grouped_by_month.find(item => item.label === label)
              return data || {
                label,
                budget: 0,
                outlook: 0,
                actual: 0,
                unit: 'USD/Ton'
              }
            })
          }
          this.bargingCostChartData = this.processLineChartData(this.bargingCostSummary?.monthlyRecap)
        }
      }
    },
    companies: {
      deep: true,
      immediate: true,
      handler(val) {
        if(val) {
          this.options.site = val.map(item => ({
            text: item.code,
            value: item.code
          }))
        }
      }
    },
    filters: {
      deep: true,
      handler() {
        this.fetchBargeLogisticTargetMonitoring()
      }
    },
    filter: {
      deep: true,
      handler() {
        this.fetchBargeLogisticTargetMonitoring()
      }
    }
  },
  mounted() {
    this.fetchBargeLogisticTargetMonitoring(),
    this.fetchCompany()
  },
  computed: {
    ...mapGetters({
      bargeLogisticTargetMonitoring: 'CostAnalysis/bargeLogisticTargetMonitoring',
      companies: 'Companies/companies'
    }),
    monthsInYear() {
      const monthRunningPerformance = []
      for (let i = 0; i <= 11; i++) {
        monthRunningPerformance.push(this.moment().month(i).format('MMM'))
      }

      return monthRunningPerformance
    },
    lineChartOptions() {
      return {
        responsive: true,
        stacked: false,
        maintainAspectRatio: false,
        layout: {
          padding: 30
        },
        scales: {
          x: {
            beginAtZero: false,
            offset: true,
            grid: {
              display: false,
              borderColor: '#000',
              borderWidth: 2,
              drawBorder: true
            },
            ticks: {
              display: true,
              font: { size: 12, family: 'Poppins' },
              color: 'rgba(0, 0, 0, 1)'
            }
          },
          y: {
            type: 'linear',
            display: true,
            offset: true,
            grid: {
              display: false,
              borderColor: '#000',
              borderWidth: 2,
              drawBorder: true
            },
            ticks: {
              display: true,
              font: { size: 12, family: 'Poppins' },
              color: 'rgba(0, 0, 0, 1)'
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            backgroundColor: '#FAFDFF',
            titleColor: '#000000',
            titleFont: {
              weight: 'Bold',
              family: 'Poppins'
            },
            titleAlign: 'center',
            bodyColor: '#000000',
            bodyFont: {
              family: 'Poppins'
            },
            bodyAlign: 'center',
            borderWidth: 1,
            cornerRadius: 6,
            displayColors: false,
            callbacks: {
              title(labelItem) {
                // Get the dataset index and data index from the first labelItem
                const datasetIndex = labelItem[0].datasetIndex;
                const chart = labelItem[0].chart;
                // Get the unit from the first dataset
                const unit = chart.data.datasets[datasetIndex].unit;
                return `${labelItem[0].label} (${unit})`;
              },
              label(tooltipItem) {
                const value = tooltipItem.raw?.toLocaleString('en-US', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                });
                return `${tooltipItem.dataset.label}: ${value}`;
              }
            }
          },
          customFill: {
            nextMonth: parseInt(this.moment().format('M'))
          },
          customTitle: {
            y: {
              display: true,
              text: 'USD',
              color: '#000000',
              font: {
                family: 'Poppins',
                size: 12
              }
            }
          }
        }
      }
    },
    lineChartPlugins() {
      return [
        this.customFillPlugin(),
        this.axisIconPlugin(),
        this.customTitlePlugin(),
        this.htmlLegendPlugin()
      ]
    }
  },
  methods: {
    async fetchBargeLogisticTargetMonitoring() {
      const filters = {
        ...this.filters,
        volume_tonnage_site: this.filter.site,
        barging_operation_month: this.filter.barging_operation_month,
        barging_cost_month: this.filter.barging_cost_month
      }
      try {
        await this.$store.dispatch('CostAnalysis/fetchBargeLogisticTargetMonitoring', filters);
      } catch (err) {
        throw err;
      }
    },
    async fetchCompany() {
      try {
        await this.$store.dispatch('Companies/fetchCompanies', {
          is_master_data: true,
          type: 'SITE_OWNER',
          status: true,
          sort_dir: 'asc',
          sort_by: 'name',
          limit:null,
          page: null
        })
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch companies, please try again')
      }
    },
    formatNumber(number) {
      return number?.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }) || 'N/A'
    },
    processLineChartData(data) {
      const currentMonth = this.moment().format("M")
      const actualData = slice(data.map(({ actual }) => actual), 0, parseInt(currentMonth))
      const outlookData = slice(data.map(({ outlook }) => outlook), parseInt(currentMonth), data.length)
      const actualOutlookDataset = {
        label: 'Actual/Outlook',
        unit: data?.[0]?.unit,
        data: [...actualData, ...outlookData],
        borderColor: '#FF0000',
        backgroundColor: '#FF0000',
        pointRadius: 4,
        borderWidth: 2
      }

      const budgetDataset = {
        label: 'Budget',
        unit: data?.[0]?.unit,
        data: data.map(({ budget }) => budget),
        borderColor: '#004479',
        backgroundColor: '#004479',
        pointRadius: 4,
        borderWidth: 2
      }

      return {
        labels: this.monthsInYear,
        datasets: [actualOutlookDataset, budgetDataset]
      }
    },
    generateOutlookClass(budget, outlook) {
      return budget > outlook ? 'green' : 'red'
    },
    customFillPlugin() {
      return {
        id: 'customFill',
        beforeDraw(chart, args, options) {
          const { ctx, chartArea: { left, right, top, bottom, height }, scales: { x, y } } = chart
          const meta = chart.getDatasetMeta(0)
          const points = meta.data
          let firstIndex = options?.nextMonth
          if(firstIndex === 12) firstIndex = 1
          const pointDistance = ((right - left) / (meta.data.length - 1)) / 2
          const yellowFillStartX = points[firstIndex].x - pointDistance
          const padding = chart?.options?.layout?.padding || 0

          ctx.fillStyle = '#FDF4BA'
          ctx.fillRect(
            yellowFillStartX,
            0,
            x.right - yellowFillStartX,
            height + padding
          )
        }
      }
    },
    axisIconPlugin() {
      return {
        id: 'axisIcons',
        afterDraw(chart, args, options) {
          const { ctx, chartArea: { top, left, right, bottom }, scales } = chart;

          const topIcon = {
            text: '\u2BC5',
            x: left,
            y: top,
            color: '#000',
            font: 'bold 20px FontAwesome'
          };

          const rightIcon = {
            text: '\u2BC8',
            x: right,
            y: bottom + 2,
            color: '#000',
            font: 'bold 20px Poppins'
          }

          ctx.save()
          ctx.font = topIcon.font
          ctx.fillStyle = topIcon.color
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(topIcon.text, topIcon.x, topIcon.y)
          ctx.restore();

          ctx.save()
          ctx.font = rightIcon.font
          ctx.fillStyle = rightIcon.color
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(rightIcon.text, rightIcon.x, rightIcon.y)
          ctx.restore()
        }
      }
    },
    customTitlePlugin() {
      return {
        id: 'customTitle',
        afterDraw(chart, args, options) {
          const { ctx, chartArea: { top, left, width } } = chart
          const axisYTicksWidth = chart.scales.y.width

          if (options?.y?.display) {
            ctx.save()
            ctx.fillStyle = options.y.color || 'black'

            const font = options.y.font || {}
            const fontSize = font.size || 10;
            const fontFamily = font.family || 'sans-serif'
            const fontWeight = font.weight || 'normal'
            ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`

            ctx.textAlign = 'center'
            ctx.textBaseline = 'top'

            const xPos = left - axisYTicksWidth / 2
            const yPos = top - 10

            ctx.fillText(options.y.text, xPos, yPos)
            ctx.restore()
          }
        }
      }
    },
    htmlLegendPlugin() {
      return {
        id: 'custom-legend',
        afterDraw(chart) {
          const ctx = chart.ctx

          const chartArea = chart.chartArea

          const chartData = chart.data
          const legendItems = chartData?.datasets?.map(({ label }) => label)
          const chartPadding = chart.options.layout.padding

          // Calculate position at bottom center
          const legendX = chartArea.left
          const legendY = chartArea.bottom + chartPadding * 1.5
          const itemWidth = 150 // Width of each legend item
          const itemHeight = 20
          const itemsPerRow =legendItems.length

          ctx.save();
          ctx.font = '12px Poppins';

          // Draw legend items in two rows
          legendItems
            .forEach((item, i) => {
              const row = Math.floor(i / itemsPerRow)
              const col = (i + 1) % itemsPerRow;
              const padding = col === 1 ? 5 : -5

              const x = legendX + chartArea.width / 2  - col * itemWidth + padding
              const y = legendY + row * (itemHeight + 5)

              // Draw colored box
              ctx.beginPath()
              ctx.roundRect(x, y, 34, 10, 5)
              ctx.fillStyle = chartData?.datasets[i]?.backgroundColor
              ctx.fill();

              // Draw text
              ctx.fillStyle = '#000'
              ctx.fillText(item.charAt(0).toUpperCase() + item.slice(1), x + 40, y + itemHeight / 2)
            });

          ctx.restore();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.logistic-container {
  @apply w-full p-5 flex flex-row items-center gap-5 bg-white rounded-lg shadow-md;
}

.card-border {
  @apply bg-white rounded-lg shadow-md;
}

.section-container {
  @apply w-full flex flex-row items-center gap-3;

  .summary-card {
    @apply px-3 py-5 flex flex-col items-start justify-start gap-5;
  }
}

.red {
  color: #FF3662;
}

.green {
  color: #33B57D;
}
</style> 